import {
  IErrorResponse,
  INoContentResponse,
} from "@krea/shared/types/response";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { useGetCurrentLoanApplicationID } from "@krea/customer-features/hooks";
import { settings } from "@krea/customer-features/settings";
import { useModalStore } from "@krea/customer-features/store/modal/hooks";
import {
  CURRENT_LOAN_APPLICATION_STORE_KEY,
  SUBMIT_APPLICATION_STORE_KEY,
} from "@krea/customer-features/store/queryClient";
import { APPLICATION_NAME } from "@krea/customer-features/utils";

import { submitApplicationAndDeleteDuplicates } from "../api";

export const useSubmitApplicationAndDeleteDuplicates = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const loanApplicationID = useGetCurrentLoanApplicationID();
  const closeModal = useModalStore((state) => state.closeModal);

  const isCustomerWeb = settings.appName === APPLICATION_NAME.CUSTOMER_WEB;

  return useMutation<INoContentResponse, IErrorResponse>({
    mutationKey: [SUBMIT_APPLICATION_STORE_KEY],
    mutationFn: async () => {
      submitApplicationAndDeleteDuplicates(loanApplicationID!);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [CURRENT_LOAN_APPLICATION_STORE_KEY, loanApplicationID],
      });

      if (isCustomerWeb) {
        navigate("/");
      } else {
        navigate(`/loan-applications/${loanApplicationID}`);
      }
    },
    onError: (err) =>
      console.error(`Failed submitting application data ${err}`),
    onSettled: closeModal,
  });
};
